module.exports = __webpack_public_path__ + "img/window-6.26aebecd.jpg";